const axios = require('axios');

export default {
    fetchAll() {
        return axios.get(process.env.VUE_APP_API_BASE_URL + "/langs");
    }
};